<button *ngIf="rowData.sameStudyInstanceNumber > 1"
        class="attached-icon-button se-button-no-ripple attached-icon-button-color"
        [disableRipple]="true"
        mat-icon-button
        matTooltipShowDelay="500"
        matTooltipClass="custom-tooltip"
        #tooltip="matTooltip"
        [matTooltip]="'HasAssociatedEcgTraces' | translate"
        (click)="onIconClick($event)">
    <mat-icon *ngIf="!loading" svgIcon="data_alert" class="attached-icon-button-color">
    </mat-icon>
    <mat-spinner *ngIf="loading"></mat-spinner>
</button>

